<template>
    <div class="row">
        <div class="col-12 mb-1">
            <div class="border rounded p-75">
                <h5>KYKM Seçimi</h5>
                <div class="row">
                    <!-- <div class="col-12 mb-1">
                        <label class="form-label">SGK Şube</label>
                        <v-select-list :options="sBranches" label="Name" v-model="SGKBranch" placeholder="SGK Şube"></v-select-list>
                    </div> -->
                    <div class="col-12 mb-1">
                        <label class="form-label">KYKM Grubu</label>
                        <v-validator :errors="errors" parameter="SalaryEffectTypeGroupId" :watch="group">
                            <v-select-list v-model="TIP" :options="groups" label="Name" placeholder="KYKM Grubu"></v-select-list>
                        </v-validator>
                    </div>
                    <div class="col-12">
                        <label class="form-label">KYKM Türü</label>
                        <v-validator :errors="errors" parameter="SalaryEffectTypeId" :watch="type">
                            <v-select-list v-model="type" :disabled="(types || []).length == 0 && this.value.SGKBranchId == null" :options="types" label="AD" placeholder="KYKM Türü">
                                <!-- <template #option="{ Name,NetsisPaymentAccountCode }">
                                    {{ Name }} - <span class="text-muted">{{ NetsisPaymentAccountCode }}</span>
                                </template> -->
                                <template #option="{ AD }">
                                    {{ AD }}
                                </template>
                            </v-select-list>
                        </v-validator>
                    </div>
                    <!-- <div class="col-12 mt-1" v-if="value.TIP==3 && value.SIRA_NO==7">
                        <b-form-checkbox inline v-model="value.AnnualHolidayAdvance">Yıllık İzin Avansı</b-form-checkbox>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="col-12 mb-1">
            <v-validator :errors="errors" parameter="ToEmployee" :watch="value.ToEmployee">
                <b-form-radio inline :value="false" class="mb-50" v-model="value.ToEmployee">Bölüm Unvanı Ataması</b-form-radio>
            </v-validator>
            <v-validator :errors="errors" parameter="ToEmployee" :watch="value.ToEmployee">
                <b-form-radio inline :value="true" v-model="value.ToEmployee">Personel Ataması</b-form-radio>
            </v-validator>
        </div>
        <template v-if="value.ToEmployee">
            <div class="col-12 mb-1">
                <label class="form-label">Personel</label>
                <v-validator :errors="errors" parameter="EmployeeDepartmentTitleId" :watch="employee">
                    <v-select-list v-model="employee" :options="employees" label="Combine" v-on:search="searchEmployees" placeholder="Personel" :loading="employeeLoading"></v-select-list>
                </v-validator>
            </div>
        </template>
        <template v-else>    
            <div class="col-12 mb-1">
                <label class="form-label">Organizasyonel Şube</label>
                <v-validator :errors="errors" parameter="BranchId" :watch="branch">
                    <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-50 mt-50" v-if="branch && collarStatuses.length">
                <b-button-group>
                    <b-button size="sm" variant="light" v-for="cs in collarStatuses" :key="cs.Id" v-on:click="setOnly(cs)">
                        Sadece <b>{{cs.Name}}</b>
                    </b-button>
                </b-button-group>
            </div>
            <div class="col-12 mb-1">
                <label class="from-label">Unvan</label> 
                <v-validator :errors="errors" parameter="EmployeeDepartmentTitleId" :watch="title">
                    <v-select-list :disabled="value.BranchId == null" multiple :options="titles" label="Name" v-model="title" placeholder="Unvan"></v-select-list>
                </v-validator>
            </div>
        </template>
        <div class="col-12 mb-1">
            <label class="form-label ml-10">Atama Kuralı</label>
            <feather-icon class="text-warning ml-50 mb-20" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Kural seçmediğiniz takdirde üst limit personelin aylık SGK maaşı olacaktır.'"></feather-icon> 
            <v-select-list :options="rules" label="Name" v-model="rule" placeholder="Atama Kuralı"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="from-label">Maaş Dönemi</label>
            <select class="form-control" v-model="value.CalculationPeriod">
                <option v-for="sp in salaryPeriods" :key="sp" :value="sp">{{sp}}</option>
            </select>
        </div>
        <div class="col-12 mb-1">
            <label class="from-label">Ödeme Tarihi</label>
            <v-validator :errors="errors" parameter="Date" :watch="value.Date">
                <v-date-picker v-model="value.Date" placeholder="Ödeme Tarihi"></v-date-picker>
            </v-validator>
        </div>
        <template v-if="$safe(type,'UCRET_NEVI') == 'M' || $safe(type,'UCRET_NEVI') == 'B'">
            <div class="col-12 mb-1">
                <label class="form-label">Tutar (TL)</label>
                <v-validator :errors="errors" parameter="Amount" :watch="value.Amount">
                    <v-currency-input  input-class="text-right" :value="value.Amount" v-on:update-value="currencyAmount => value.Amount = currencyAmount"></v-currency-input>
                </v-validator>
            </div>
        </template>
        <template v-if="$safe(type,'UCRET_NEVI') == 'U'">
            <div class="col-12 mb-1">
                <label class="form-label">Gün</label>
                <v-validator :errors="errors" parameter="Amount" :watch="value.Amount">
                    <input class="form-control" type="number" placeholder="Gün" v-model="value.Amount">
                </v-validator>
            </div>
        </template>
        <template v-if="$safe(type,'UCRET_NEVI') == 'S'">
            <div class="col-12 mb-1">
                <label class="form-label">Saat</label>
                <v-validator :errors="errors" parameter="Amount" :watch="value.Amount">
                    <input class="form-control" type="number" placeholder="Saat" v-model="value.Amount">
                </v-validator>
            </div>
        </template>
        <!-- <div class="col-12 mb-1" v-else>
            <div class="table-responsive mb-0">
                <table class="table table-bordered table-sm">
                    <tbody>
                        <tr>
                            <th class="w-50 bg-light">PERİYOT</th>
                            <td class="w-50">{{ $safe(type,'Period.Period') }} {{ $safe(type,'Period.Monthly') ? 'Ayda' : 'Günde' }} Bir</td>
                        </tr>
                        <tr>
                            <th class="w-50 bg-light">EKSİK GÜN TOLERANSI</th>
                            <td class="w-50">{{ $safe(type,'Period.LackOfDayTolerance') || '-'}} </td>
                        </tr>
                        <tr>
                            <th colspan="2" class="bg-light-primary">İŞE GİRİŞ TARİHİ, AYIN;</th>
                        </tr>
                        <tr>
                            <th class="w-50 text-primary">{{$safe(type,'Period.FirstJobStartDay')}}. gününden öncesinde</th>
                            <td class="w-50">
                                <template v-if="$safe(type,'Period.BJSFixedAmount') == true">
                                    Sabit Tutar (TL) <strong>[{{$safe(type,'Period.BJSAmount')}}]</strong>
                                </template>
                                <template v-else-if="$safe(type,'Period.BJSFixedAmount') == false">
                                    Hakedilen Maaş
                                </template>
                                <template v-else>-</template>
                            </td>
                        </tr>
                        <tr>
                            <th class="w-50 text-primary">{{$safe(type,'Period.FirstJobStartDay')}}. ve {{$safe(type,'Period.SecondJobStartDay')}}. günleri arasında</th>
                            <td class="w-50">
                                <template v-if="$safe(type,'Period.BFSFixedAmount') == true">
                                    Sabit Tutar (TL) <strong>[{{$safe(type,'Period.BFSAmount')}}]</strong>
                                </template>
                                <template v-else-if="$safe(type,'Period.BFSFixedAmount') == false">
                                    Hakedilen Maaş
                                </template>
                                <template v-else>-</template>
                            </td>
                        </tr>
                        <tr>
                            <th class="w-50 text-primary">{{$safe(type,'Period.SecondJobStartDay')}}. gününden sonrasında</th>
                            <td class="w-50">
                                <template v-if="$safe(type,'Period.ASFixedAmount') == true">
                                    Sabit Tutar (TL) <strong>[{{$safe(type,'Period.ASAmount')}}]</strong>
                                </template>
                                <template v-else-if="$safe(type,'Period.ASFixedAmount') == false">
                                    Hakedilen Maaş
                                </template>
                                <template v-else>-</template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> -->
       
        <!-- <div class="col-12">
            <b-form-checkbox v-model="value.TMSVault">TMS Kasa</b-form-checkbox>
        </div> -->
    </div>
</template>

<script>
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import EmployeeOperationsApi from '@/api/employee-operations'
import CompanyApi from '@/api/company'
import { BFormRadio,BFormCheckbox,BButtonGroup,BButton } from 'bootstrap-vue'
import moment from 'moment'
import NetsisApi from '@/api/hr-netsis'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import { VBTooltip } from 'bootstrap-vue'

export default {
    props:{
        value:Object,
        errors:Object
    },
    components:{
        BFormRadio,
        BFormCheckbox,
        BButton,
        BButtonGroup,
        VCurrencyInput
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    data() {
        return {
            types:[],
            groups:[],
            branches:[],
            sBranches:[],
            titles:[],
            employeeLoading:false,
            employees:[],
            groups:[
                {Name:'Kazanç',Id:1},
                {Name:'Yardım',Id:2},
                {Name:'Kesinti',Id:3},
                {Name:'Muafiyet',Id:4}
            ],
            group:null,
            rules:[]
        }
    },
    watch:{
        "value.TIP"(){
            this.types = []
            this.getKYKMs()
        },
        "value.BranchId"(){
            this.value.EmployeeDepartmentTitleId = null
            this.getTitles()
        },
        "value.SGKBranchId"(){
            this.getSalaryEffectTypes()
            this.value.EmployeeId = null
        }
    },
    mounted(){
        this.getBranches("O")
        this.getBranches("S")
        this.controlDate()
        this.getRules()
    },
    methods:{
        getBranches(type){
            CompanyApi.Branch.ListByCode(type).then(res=>{ 
                if(type == "O"){
                    this.branches = res.data.Data
                }else{
                    this.sBranches = res.data.Data
                }
            })
        },
        getTitles(){
            if(this.value.BranchId){
                HumanResourcesParameterApi.EmployeeDepartmentTitle.List(this.value.BranchId).then(res=>{
                    this.titles = res.data.Data
                })
            }
        },
        getRules(){
            EmployeeOperationsApi.SalaryEffect.Assign.Rule.List().then(res=> {
                this.rules = res.data.Data
            })
        },
        getKYKMs(){
            if(this.value.TIP){
                NetsisApi.KYKMListByCode(this.value.TIP).then(res=>{
                    this.types = res.data
                })
            }
        },
        searchEmployees(search){
            if(search){
                this.employeeLoading = true
                EmployeeOperationsApi.Employee.Search(search)
                .then(res=>{
                    this.employees = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.IdentityNumber,d.FullName].join(' - ')
                    }))
                    this.employeeLoading = false
                }).catch(err=>{ 
                    this.employeeLoading = false 
                })
            }
        },
        disabledDate(date){
            if(this.type){
                let currentDate = moment(date)
                if(currentDate.isBefore(moment(),'days')){
                    return true
                }else false
            }else return true
        },
        setOnly(cs){
            this.title = this.titles.filter(t=>t.CollarStatusId == cs.Id)
        },
        controlDate(){
            let dayIndex = moment().day()
            if(dayIndex == 5 || dayIndex == 6 || dayIndex == 0){
                this.value.Date = moment().startOf('isoWeek').add(1, 'week').day("monday").format('YYYY-MM-DD')
            }else{
                this.value.Date = moment().add(1,'day').format('YYYY-MM-DD')
            }
        }
    },
    computed:{
        TIP:{
            get:function(){
                return this.groups.find(b=>b.Id==this.value.TIP)
            },
            set:function(value){
                this.value.TIP = value?.Id || null
                this.value.TIP_AD = value?.Name || null
            }
        },
        type:{
            get:function(){
                return this.types.find(b=>b.SIRA_NO==this.value.SIRA_NO)
            },
            set:function(value){
                this.value.SIRA_NO = value?.SIRA_NO || null
                this.value.SIRA_NO_AD = value?.AD || null
                this.value.UCRET_NEVI = value?.UCRET_NEVI || null
                this.value.CARPAN = value?.CARPAN || null
            }
        },
        title:{
            get:function(){
                return this.titles.filter(b=>this.value.EmployeeDepartmentTitleIds.includes(b.Id))
            },
            set:function(value){
                this.value.EmployeeDepartmentTitleIds =value?.map(v=>v.Id) || []
            }
        },
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.value.BranchId)
            },
            set:function(value){
                this.value.BranchId = value?.Id || null
            }
        },
        SGKBranch:{
            get:function(){
                return this.sBranches.find(b=>b.Id==this.value.SGKBranchId)
            },
            set:function(value){
                this.value.SGKBranchId = value?.Id || null
            }
        },
        employee:{
            get:function(){
                return this.employees.find(s=>s.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
        collarStatuses(){
            return this.titles.filter(t=>t.CollarStatusId != null).map(t=>({
                Id:t.CollarStatusId,
                Name:t.CollarStatusName
            })).filter((v,i,s)=> s.findIndex(t=>t.Id == v.Id) === i)
        },
        salaryPeriods(){
            let periods = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 2020
            while (firstYear <= year){
                const m = firstYear == year ? moment().month() + 1 : 12
                for(let i=1;  i <= m; i++){
                    periods.push(`${String(i).padStart(2,0)}/${firstYear}`)
                }
                firstYear ++
            }
            return periods.reverse()
        },
        rule:{
            get:function(){
                return this.rules.find(b=>b.Id==this.value.RuleId)
            },
            set:function(value){
                this.value.RuleId = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>